import { render } from "./SponsorView.vue?vue&type=template&id=5241351c"
import script from "./SponsorView.vue?vue&type=script&lang=js"
export * from "./SponsorView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AlterLau\\walter-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__